module.exports = __webpack_public_path__ + "static/media/alert_icon.ebcc7765.png";